const useRemoveBackspaces = (string) => string.replace(/\n\s+/g, ' ').replace(/\s?$/, '');

export default useRemoveBackspaces;
